export const ROUTE_PATH = '/sale-turnover/:storeId';

export const FEATURE_NAME = 'salesTurnoverDetailsPage';
